(() => {
  if (window.HorecalaanAttribution) return;
  const storageKey = 'hl_attribution_v1';
  const maxAge = 90 * 86400000;
  const entryUrl = new URL(location.href);
  const referrer = document.referrer;
  const fields = ['gclid', 'gbraid', 'wbraid', 'utm_source', 'utm_medium', 'utm_campaign', 'utm_id', 'utm_term', 'utm_content', 'campaignid', 'adgroupid'];
  const cartKeys = ['HL - première origine', 'HL - dernière origine', 'HL - campagne publicitaire', 'HL - identifiant de clic', 'HL - attribution JSON'];
  let state = null;
  let allowed = false;
  let started = false;
  let queued = false;
  let cartChain = Promise.resolve();
  let lastSaved = '';
  const clip = (value, length = 250) => String(value || '').replace(/[\u0000-\u001f]/g, '').slice(0, length);
  const privacyAllowed = () => {
    try { return window.Shopify?.customerPrivacy?.marketingAllowed() === true; } catch { return false; }
  };
  function touchpoint() {
    const point = { at: new Date().toISOString(), landing: entryUrl.pathname.slice(0, 400) };
    fields.forEach(key => {
      const value = entryUrl.searchParams.get(key);
      if (value) point[key] = clip(value);
    });
    if (point.gclid || point.gbraid || point.wbraid) {
      point.source = 'google';
      point.medium = 'cpc';
    } else if (point.utm_source) {
      point.source = point.utm_source;
      point.medium = point.utm_medium || 'unknown';
    } else {
      let host = '';
      try { host = new URL(referrer).hostname; } catch {}
      if (host && !['horecalaan.com', 'www.horecalaan.com', 'horecalaan.shop', 'www.horecalaan.shop', location.hostname].includes(host)) {
        point.source = host;
        point.medium = /(^|\.)(google\.[a-z.]+|bing\.com|duckduckgo\.com)$/.test(host) ? 'organic' : 'referral';
      } else {
        point.source = 'direct';
        point.medium = 'none';
      }
    }
    point.campaign_id = clip(point.campaignid || point.utm_id);
    return point;
  }
  const isPaid = point => !!(point.gclid || point.gbraid || point.wbraid || /^(cpc|ppc|paid|paid_search|paid_social|display|cpm)$/i.test(point.medium));
  function getState() {
    let saved;
    try { saved = JSON.parse(localStorage.getItem(storageKey)); } catch {}
    if (saved?.version !== 1) saved = null;
    const now = Date.now();
    const valid = point => point && Number.isFinite(Date.parse(point.at)) && now - Date.parse(point.at) >= 0 && now - Date.parse(point.at) <= maxAge;
    state = saved || { version: 1 };
    ['first', 'last_non_direct', 'last_paid'].forEach(key => { if (!valid(state[key])) delete state[key]; });
    const current = touchpoint();
    if (!state.first) state.first = current;
    if (current.source !== 'direct') state.last_non_direct = current;
    if (isPaid(current)) state.last_paid = current;
    try { localStorage.setItem(storageKey, JSON.stringify(state)); } catch {}
  }
  function attributes() {
    if (!privacyAllowed() || !state) return {};
    const describe = point => point ? [point.source, point.medium, point.utm_campaign || point.campaign_id, point.at].filter(Boolean).join(' | ') : '';
    const paid = state.last_paid;
    return {
      [cartKeys[0]]: describe(state.first),
      [cartKeys[1]]: describe(state.last_non_direct || state.first),
      [cartKeys[2]]: paid ? [paid.campaign_id, paid.utm_campaign].filter(Boolean).join(' | ') : '',
      [cartKeys[3]]: paid ? ['gclid', 'gbraid', 'wbraid'].filter(key => paid[key]).map(key => key + '=' + paid[key]).join(' | ') : '',
      [cartKeys[4]]: JSON.stringify(state)
    };
  }
  function setInput(input, value) {
    if (input.value === value) return;
    const prototype = input.tagName === 'TEXTAREA' ? HTMLTextAreaElement.prototype : HTMLInputElement.prototype;
    Object.getOwnPropertyDescriptor(prototype, 'value').set.call(input, value);
    input.dispatchEvent(new Event('input', { bubbles: true }));
    input.dispatchEvent(new Event('change', { bubbles: true }));
  }
  function fill() {
    const data = attributes();
    document.querySelectorAll('form').forEach(form => {
      const contact = form.querySelector('input[name="form_type"][value="contact"]');
      const isCart = /\/cart\/?$/.test(new URL(form.action || location.href, location.origin).pathname);
      if (!contact && !isCart) return;
      cartKeys.forEach(key => {
        const name = contact ? `contact[${key}]` : `attributes[${key}]`;
        let input = Array.from(form.elements).find(element => element.name === name);
        if (!data[key]) { input?.remove(); return; }
        if (!input) {
          input = document.createElement('input');
          input.type = 'hidden';
          input.name = name;
          input.dataset.hlAttribution = 'true';
          form.append(input);
        }
        input.value = data[key];
      });
    });
    document.querySelectorAll('.hl-attribution-data').forEach(element => {
      const input = element.matches('input,textarea') ? element : element.querySelector('input,textarea');
      if (input) setInput(input, data[cartKeys[4]] || '');
    });
    document.documentElement.dataset.hlAttribution = Object.keys(data).length ? 'ready-v1' : 'consent-required';
    document.documentElement.dataset.hlAttributionPaid = String(!!(privacyAllowed() && state?.last_paid));
    document.documentElement.dataset.hlAttributionCampaign = String(!!(privacyAllowed() && state?.last_paid?.campaign_id));
  }
  function saveCart(clear = false) {
    const data = clear ? Object.fromEntries(cartKeys.map(key => [key, ''])) : attributes();
    if (!Object.keys(data).length) return cartChain;
    const signature = JSON.stringify(data);
    if (signature === lastSaved) return cartChain;
    const root = window.Shopify?.routes?.root || '/';
    cartChain = cartChain.catch(() => {}).then(async () => {
      if (!clear && !privacyAllowed()) return;
      const response = await fetch(root + 'cart/update.js', {
        method: 'POST', credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ attributes: data })
      });
      if (response.ok) lastSaved = signature;
    }).catch(() => {});
    return cartChain;
  }
  function refreshConsent() {
    const previous = allowed;
    allowed = privacyAllowed();
    if (allowed && !started) { getState(); started = true; }
    if (!allowed) {
      state = null;
      started = false;
      let declined = false;
      try { declined = window.Shopify?.customerPrivacy?.currentVisitorConsent()?.marketing === 'no'; } catch {}
      if (previous || declined) {
        try { localStorage.removeItem(storageKey); } catch {}
        saveCart(true);
      }
    }
    fill();
    if (allowed) saveCart();
  }
  window.HorecalaanAttribution = { attributes, flush: () => saveCart() };
  const scheduleFill = () => {
    if (queued) return;
    queued = true;
    queueMicrotask(() => { queued = false; fill(); });
  };
  new MutationObserver(scheduleFill).observe(document.body, { childList: true, subtree: true });
  document.addEventListener('submit', fill, true);
  document.addEventListener('visitorConsentCollected', refreshConsent);
  document.addEventListener('shopifyCustomerPrivacyApiLoaded', refreshConsent);
  window.addEventListener('pageshow', refreshConsent);
  refreshConsent();
  if (!window.Shopify?.customerPrivacy && window.Shopify?.loadFeatures) {
    window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], error => { if (!error) refreshConsent(); });
  }
})();
